module.exports = {
    GOOGLE_MAPS_API_KEY: 'AIzaSyDQwgPqNeqBNKbb2KSa2FZMxQOoSZ8Vz6o'
};
